import { Injectable, signal, computed } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loadingCount = signal(0);
  
  // Computed property to determine if any loading is happening
  isLoading = computed(() => this.loadingCount() > 0);

  /**
   * Increment loading count
   */
  show(): void {
    this.loadingCount.update(count => count + 1);
  }

  /**
   * Decrement loading count
   */
  hide(): void {
    this.loadingCount.update(count => Math.max(0, count - 1));
  }

  /**
   * Force reset loading count (e.g. on navigation error)
   */
  reset(): void {
    this.loadingCount.set(0);
  }
}
